// extracted by mini-css-extract-plugin
module.exports = {"root":"CustomTip_root__3XDLt","inputWrap":"CustomTip_inputWrap__2Akoe"};